import { render, staticRenderFns } from "./ProposalReviewPanelDetail.vue?vue&type=template&id=524245c4"
import script from "./ProposalReviewPanelDetail.vue?vue&type=script&lang=js"
export * from "./ProposalReviewPanelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports